import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Product from 'src/app/model/product/product';
import ProjectContact from 'src/app/model/company/projectContact';
import ProductPhoneNumber from 'src/app/model/product/product-phone-number';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { StringHelper } from 'src/app/helpers/string-helper';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'product-phone-number-selector',
  templateUrl: './product-phone-number-selector.component.html',
  styleUrls: ['./product-phone-number-selector.component.scss'],
  providers: [FormatPhoneNumber],
})
export class ProductPhoneNumberSelectorComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  inputProduct: Product;
  @Input()
  inputProjectContact: ProjectContact;

  @Output()
  numberChanged = new EventEmitter<any>();

  init = false;
  numbers: string[];
  productPhoneNumber: ProductPhoneNumber;
  alternateProductPhoneNumber: ProductPhoneNumber;
  alternateProductPhoneNumberInArray = false;
  displayProjectContact: string;

  constructor(
    public formatPhoneNumber: FormatPhoneNumber,
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit() {
    this.calculateDisplayProjectContact();
    this.getPhoneNumbers();
    if (this.inputProduct.productPhoneNumbers == null) {
      this.inputProduct.productPhoneNumbers = [];
    }
    this.inputProduct.productPhoneNumbers.forEach((ppn) => {
      if (
        (this.numbers.includes(ppn.phoneNumbers) ||
          ppn.phoneNumbers === 'Geen') &&
        ppn.projectContact != null &&
        ppn.projectContact.id == this.inputProjectContact.id
      ) {
        this.productPhoneNumber = ppn;
      } else if (
        ppn.projectContact != null &&
        ppn.projectContact.id == this.inputProjectContact.id
      ) {
        this.alternateProductPhoneNumber = ppn;
        this.alternateProductPhoneNumberInArray = true;
      }
    });
    if (this.alternateProductPhoneNumber == null) {
      let product = new Product();
      product.id = this.inputProduct.id;
      product.type = this.inputProduct.type;
      let projectContact = new ProjectContact();
      projectContact.id = this.inputProjectContact.id;
      this.alternateProductPhoneNumber = new ProductPhoneNumber(
        product,
        projectContact
      );
    }
    if (this.productPhoneNumber == null) {
      // find product phone number in array that is not the alternateProductPhoneNumber
      for (let ppn of this.inputProduct.productPhoneNumbers) {
        if (
          ppn.projectContact.id === this.inputProjectContact.id &&
          ppn != this.alternateProductPhoneNumber
        ) {
          this.productPhoneNumber = ppn;
          break;
        }
      }
      // if productPhoneNumber still not set, create new and add it to array
      if (this.productPhoneNumber == null) {
        let product = new Product();
        product.id = this.inputProduct.id;
        product.type = this.inputProduct.type;
        let projectContact = new ProjectContact();
        projectContact.id = this.inputProjectContact.id;
        this.productPhoneNumber = new ProductPhoneNumber(
          product,
          projectContact
        );
        this.inputProduct.productPhoneNumbers.push(this.productPhoneNumber);
      }
    }
    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.calculateDisplayProjectContact();
      }
    );
    this.init = true;
  }

  getPhoneNumbers() {
    this.numbers = ['Geen'];
    for (let phoneObject of this.inputProjectContact.contact.telephones) {
      this.numbers.push(phoneObject.number);
    }
    for (let phoneObject of this.inputProjectContact.company.telephones) {
      this.numbers.push(phoneObject.number);
    }
  }

  productPhoneNumberChange(event) {
    this.productPhoneNumber.phoneNumbers = event;
    this.projectDisplayObservableService
      .getProductPhoneNumberChangedSubscribable()
      .next();
    this.numberChanged.emit();
  }

  alternateProductPhoneNumberChange(number: string) {
    if (number != null) {
      this.alternateProductPhoneNumber.phoneNumbers =
        this.formatPhoneNumber.transform(number);
      if (
        this.alternateProductPhoneNumberInArray &&
        (this.alternateProductPhoneNumber.phoneNumbers == null ||
          this.alternateProductPhoneNumber.phoneNumbers === '')
      ) {
        let index = this.inputProduct.productPhoneNumbers.indexOf(
          this.alternateProductPhoneNumber
        );
        this.inputProduct.productPhoneNumbers.splice(index, 1);
        this.alternateProductPhoneNumberInArray = false;
      }
      if (
        !this.alternateProductPhoneNumberInArray &&
        this.alternateProductPhoneNumber.phoneNumbers != null &&
        this.alternateProductPhoneNumber.phoneNumbers !== ''
      ) {
        this.inputProduct.productPhoneNumbers.push(
          this.alternateProductPhoneNumber
        );
        this.alternateProductPhoneNumberInArray = true;
      }
      this.projectDisplayObservableService
        .getProductPhoneNumberChangedSubscribable()
        .next();
      this.numberChanged.emit();
    }
  }

  calculateDisplayProjectContact() {
    this.displayProjectContact =
      StringHelper.join(
        [
          this.inputProjectContact.contact == null
            ? null
            : this.inputProjectContact.contact.firstName,
          this.inputProjectContact.contact == null
            ? null
            : this.inputProjectContact.contact.lastName,
        ],
        ' '
      ) +
      ' (' +
      (this.inputProjectContact.company == null
        ? ''
        : this.inputProjectContact.company.regularName) +
      ')';
  }
}
